import dayjs from 'dayjs';
require('dayjs/locale/en');

export function formatBirthDate(dob: string): string {
  var dateVal = dayjs(dob).locale('en');
  var formattedDate = dateVal.format('MM/DD/YYYY');
  return formattedDate;
}
